import projectStageTaskMember from "./project-stage-task-member";
import projectStagesTasks from "./project-stages-tasks";

export default {
  projectStagesTasks,
  projectStageTaskMember,
};
